import { useEffect } from 'react';
import { SET_VALUE } from '@/components/common/notes/show-note-forms/dataToSendReducer';

interface Props {
    formId: string;
    formName: string;
    formDispatch: any;
    item: {
        name: string;
        value: string;
    };
}

const HiddenFieldComponent = ({ formDispatch, formId, formName, item: { name: fieldId, value } }: Props) => {
    useEffect(() => {
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
    }, []);

    return null;
};

export default HiddenFieldComponent;
